import { Add, Remove } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Announcement from "../components/Announcement";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { mobile, tablet } from "../responsive";
import StripeCheckout from "react-stripe-checkout";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom"
import { deleteProduct, incProduct, decProduct } from "../redux/cartRedux";
import { MdDeleteOutline } from "react-icons/md";
import { IoCartOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import apiRequest from "../api";
import { toast } from "react-toastify";
const KEY = process.env.REACT_APP_STRIPE;


const Container = styled.div``;

const Wrapper = styled.div`
  padding: 20px;
  ${mobile({ padding: "10px" })}
`;

const Title = styled.h1`
  font-weight: 300;
  text-align: center;
  ${mobile({ fontSize: "24px" })}

`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  ${mobile({ padding: "20px 0" })}
  
`;

const TopButton = styled.button`
  padding: 10px;
  font-weight: 600;
  cursor: pointer;
  border: ${(props) => props.type === "filled" && "none"};
  background-color: ${(props) =>
    props.type === "filled" ? "black" : "transparent"};
  color: ${(props) => props.type === "filled" && "white"};
  ${mobile({ fontSize: "14px" })}
  &:hover {
    background-color: black; 
    color: white;
  }
`;

const TopTexts = styled.div`
  ${mobile({ display: "none" })}
`;
const TopText = styled.span`
  text-decoration: underline;
  cursor: pointer;
  margin: 0px 10px;
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  ${tablet({ flexDirection: "column", justifyContent: "center", alignItems: "center" })}
`;

const Info = styled.div`
  flex: 3;
`;

const Product = styled.div`
  display: flex;
  justify-content: space-between;
  align-items:center;
  margin:10px 0;
`;

const ProductDetail = styled.div`
  flex: 2;
  display: flex;
`;

const Image = styled.img`
  width: 200px;
  height:200px;
  object-fit:cover;
  ${mobile({ width: "100px", height: "75px" })}
`;

const Details = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  ${mobile({ padding: "0 10px" })}

`;

const ProductName = styled.span`
  ${mobile({ fontSize: "14px" })}

`;

const ProductId = styled.span`
  ${mobile({ fontSize: "12px" })}
`;

const ProductColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  ${mobile({ height: "15px", width: "15px" })}

`;

const ProductSize = styled.span`
  ${mobile({ fontSize: "14px" })}
`;

const PriceDetail = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ProductAmountContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  ${mobile({ marginBottom: "0px" })}
  
`;

const ProductAmount = styled.div`
  font-size: 24px;
  margin: 5px;
  ${mobile({ fontSize: "16px", margin: "0px" })}


`;

const ProductPrice = styled.div`
  font-size: 30px;
  font-weight: 200;
  ${mobile({ fontSize: "16px" })}

`;

const Hr = styled.hr`
  background-color: #eee;
  border: none;
  height: 1px;
`;

const Summary = styled.div`
  flex: 1;
  border: 0.5px solid lightgray;
  border-radius: 10px;
  padding: 20px;
  height: 50vh;
  ${mobile({ padding: "10px", width: "100%", marginTop: "10px" })}

`;

const SummaryTitle = styled.h1`
  font-weight: 200;
  ${mobile({ fontSize: "24px" })}

`;

const SummaryItem = styled.div`
  margin: 30px 0px;
  display: flex;
  justify-content: space-between;
  font-weight: ${(props) => props.type === "total" && "500"};
  font-size: ${(props) => props.type === "total" && "24px"};
`;

const SummaryItemText = styled.span``;

const SummaryItemPrice = styled.span``;

const Button = styled.button`
  width: 100%;
  padding: 10px;
  background-color: black;
  color: white;
  font-weight: 600;
  margin-top:10px;
  &:hover {
    background-color:white;
    color: black; 
  }
`;
const Empty = styled.h1`
position:absolute;
top:50%;
right:50%;
display:flex;
align-items:center;
font-weight:300;
${tablet({ display: 'none' })}


`;
const DetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const DeleteIcon = styled.div`
font-size:2rem;
margin-right:2rem;
color:red;
${mobile({ fontSize: "1.25rem", marginRight: "0px", })}
`;

const Cart = () => {
  const user=useSelector((state)=>state.user.currentUser);
  console.log("user",user);
  const cart = useSelector((state) => state.cart);
  const [stripeToken, setStripeToken] = useState(null);
  const dispatch = useDispatch();
  const Navigation = useNavigate();
  const shippingCharges = 10;
  const shippingDiscount = 5;

  const handleClick=()=>{
    toast.error("Before Checkout You have to login first.")
    Navigation("/login")
  }

  const onToken = (token) => {
    setStripeToken(token);
  };
  // console.log(cart.products);

  useEffect(() => {


    const makeRequest = async () => {

      const res = await apiRequest("POST", "checkout/payment", {
        tokenId: stripeToken.id,
        amount: 500,
      });
      if (res?.status == 200) {
        Navigation("/success", {
          state: {
            stripeData: res.data,
            products: cart
          }
        })
      }

    };
    stripeToken && makeRequest();
  }, [stripeToken]);

  const handleAdd = (product) => {
    dispatch(incProduct(product));
  }
  const deleteProducts = (product) => {
    dispatch(deleteProduct(product));
  }
  const handleMinus = (product) => {
    dispatch(decProduct(product))
  }
  const showTotal = useMemo(() => {
    let total = 0;

    for (let i = 0; i < cart.products.length; i++) {
      total = total + cart.products[i].price * cart.products[i].quantity;
    }
    return total;
  }, [cart])

  return (
    <Container>
      <Navbar />
      <Announcement />
      <Wrapper>
        <Title>YOUR BAG</Title>
        <Top>
          <Link to='/'><TopButton>CONTINUE SHOPPING</TopButton></Link>
          <TopTexts>
            <TopText>Shopping Bag(2)</TopText>
            <TopText>Your Wishlist (0)</TopText>
          </TopTexts>
          {/* <TopButton type="filled">CHECKOUT NOW</TopButton> */}
        </Top>
        <Bottom>
          {cart.products.length == 0
            ? <Empty>Empty Cart <IoCartOutline /></Empty>
            : null}
          <Info>
            {cart.products.map((product, index) => (
              <Product key={`${index}`}>
                <ProductDetail>
                  <Image src={`${process.env.REACT_APP_BASE_URL}${product.img}`} />
                  <DetailsWrapper>
                    <Details>
                      <ProductName>
                        <b>Product:</b> {product.title}
                      </ProductName>
                      <ProductId>
                        <b>ID:</b> {product._id}
                      </ProductId>
                      <ProductColor color={product.color} />
                      <ProductSize>
                        <b>Size:</b> {product.size}
                      </ProductSize>
                    </Details>
                    <PriceDetail>
                      <ProductAmountContainer>
                        <Add onClick={() => handleAdd(product)} />
                        <ProductAmount>{product.quantity}</ProductAmount>
                        <Remove onClick={() => handleMinus(product)} />
                      </ProductAmountContainer>
                      <ProductPrice>
                        $ {product.price}
                      </ProductPrice>
                      <DeleteIcon><MdDeleteOutline onClick={() => deleteProducts(product)} />
                      </DeleteIcon>
                    </PriceDetail>
                  </DetailsWrapper>

                </ProductDetail>

              </Product>
            ))}
            <Hr />
          </Info>
          <Summary>
            <SummaryTitle>ORDER SUMMARY</SummaryTitle>
            <SummaryItem>
              <SummaryItemText>Subtotal</SummaryItemText>
              <SummaryItemPrice>$ {showTotal}</SummaryItemPrice>
            </SummaryItem>
            <SummaryItem>
              <SummaryItemText>Estimated Shipping</SummaryItemText>
              <SummaryItemPrice>$ {shippingCharges}</SummaryItemPrice>
            </SummaryItem>
            <SummaryItem>
              <SummaryItemText>Shipping Discount</SummaryItemText>
              <SummaryItemPrice>$ -{shippingDiscount}</SummaryItemPrice>
            </SummaryItem>
            <SummaryItem type="total">
              <SummaryItemText>Total</SummaryItemText>
              <SummaryItemPrice>$ {showTotal + shippingCharges - shippingDiscount}</SummaryItemPrice>
            </SummaryItem>
            {user
            ?<StripeCheckout
              name="Shop Online"
              image="https://avatars.githubusercontent.com/u/1486366?v=4"
              billingAddress
              shippingAddress
              description={`Your total is $${showTotal + shippingCharges - shippingDiscount}}`}
              amount={cart.total * 100}
              token={onToken}
              stripeKey={KEY}
            >
              <Button>CHECKOUT NOW</Button>
            </StripeCheckout>
            :<Button onClick={handleClick}>CHECKOUT NOW</Button>
            }

          </Summary>
        </Bottom>
      </Wrapper>
      <Footer />
    </Container>
  );
};

export default Cart;
